import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSingleSubCategoryAction = createAsyncThunk(
    'get-single-sub-category',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-single-sub-category/${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSingleSubCategorySlice = createSlice({
    name: 'get-single-sub-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSingleSubCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSingleSubCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSingleSubCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSingleSubCategoryReducer = getSingleSubCategorySlice.reducer    